import React from 'react';
import { Frame, SageClassnames, Card, Divider } from '@kajabi/sage-react';

const PaypalLogo = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.524 5.64844H17.2938C20.9282 5.64844 22.2967 7.48823 22.0854 10.1956C21.7369 14.6588 19.0384 17.1268 15.4592 17.1268H13.6522C13.1616 17.1268 12.8315 17.451 12.6981 18.3323L11.9228 23.4488C11.8724 23.7812 11.6976 23.9764 11.435 24H7.19008C6.79066 24 6.64855 23.6944 6.75311 23.0326L9.34537 6.61939C9.44923 5.96163 9.80907 5.64844 10.524 5.64844Z"
      fill="#009CDE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.2911 0H13.0677C14.9763 0 17.2399 0.0619599 18.7542 1.3975C19.7658 2.28967 20.2967 3.71109 20.1741 5.23705C19.7585 10.4116 16.6633 13.3098 12.5128 13.3098H9.17058C8.60173 13.3098 8.22466 13.6867 8.06422 14.7076L7.13158 20.6405C7.0711 21.0254 6.90423 21.2522 6.59963 21.2796H2.42523C1.96202 21.2796 1.79734 20.9253 1.91855 20.1578L4.92446 1.12586C5.04492 0.36316 5.4621 0 6.2911 0Z"
      fill="#003087"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.16138 14.1095L9.34485 6.61933C9.44871 5.96157 9.80854 5.64844 10.5235 5.64844H17.2933C18.414 5.64844 19.3194 5.82338 20.029 6.14586C19.3488 10.7509 16.3703 13.3098 12.4696 13.3098H9.12747C8.68744 13.3098 8.3588 13.5346 8.16138 14.1095Z"
      fill="#012169"
    />
  </svg>
);

const MoveRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C6 11.4477 6.44772 11 7 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H7C6.44772 13 6 12.5523 6 12Z"
      fill="#8D939A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L16.7071 18.7071C16.3166 19.0976 15.6834 19.0976 15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929L20.5858 12L15.2929 6.70711C14.9024 6.31658 14.9024 5.68342 15.2929 5.29289Z"
      fill="#8D939A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1C2.55228 1 3 1.44772 3 2V22C3 22.5523 2.55228 23 2 23C1.44772 23 1 22.5523 1 22V2C1 1.44772 1.44772 1 2 1Z"
      fill="#8D939A"
    />
  </svg>
);

const PaypalDetailsCard = () => (
  <Card outline="true">
    <Frame
      direction={Frame.DIRECTIONS.VERTICAL}
      gap={Frame.GAPS.NONE}
      width={Frame.WIDTHS.FILL}
      maxWidth="100%"
    >
      <div className={SageClassnames.SPACERS.XS_BOTTOM}>
        <PaypalLogo />
      </div>
      <h5
        className={`${SageClassnames.TYPE.BODY} ${SageClassnames.TYPE_COLORS.CHARCOAL_400}`}
        style={{ fontWeight: 450 }}
      >
        Pay with PayPal.
      </h5>
      <Divider />
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        className={SageClassnames.SPACERS.XS_TOP}
        gap={Frame.GAPS.XS}
        align={Frame.ALIGNMENTS.CENTER}
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <MoveRightIcon />
        <span
          className={`${SageClassnames.TYPE.BODY_SMALL} ${SageClassnames.TYPE_COLORS.CHARCOAL_100}`}
        >
          After submission, you will be redirected to securely complete next steps.
        </span>
      </Frame>
    </Frame>
  </Card>
);

export default PaypalDetailsCard;
